import { useTranslation } from "react-i18next";
import { DepartmentManagerRow } from "./DepartmentManagerRow";
import { localName } from "../../lib/localName";

const IN = "w-full rounded-2xl border border-border/50 bg-background px-4 py-2.5 text-sm shadow-neu-sm outline-none focus:ring-2 focus:ring-primary/40";
const LB = "text-[11px] font-bold uppercase tracking-wider text-muted-foreground";

// حقلا الفرع + المدير: قفل الفرع تلقائياً عند التعديل + صف مدير القسم مباشرة أسفله.
export const DeptBranchManager = ({ form, onChange, managers, branches, mgrMap, isEdit }) => {
  const { t } = useTranslation();
  const set = (k) => (e) => onChange({ ...form, [k]: e.target.value });
  const manager = managers.find((m) => m.id === form.manager_id);
  return (
    <>
      <div>
        <span className={LB}>{t("departments.form.branch")}</span>
        <select
          className={`${IN} mt-1.5 ${isEdit ? "cursor-not-allowed opacity-70" : ""}`}
          value={form.branch_id || ""}
          onChange={set("branch_id")}
          disabled={isEdit}
          data-testid="dept-branch"
        >
          <option value="">{t("departments.form.noBranch")}</option>
          {branches.map((b) => (
            <option key={b.id} value={b.id}>{localName(b)}</option>
          ))}
        </select>
        {isEdit ? (
          <p className="mt-1 text-[10px] text-amber-600 dark:text-amber-400" data-testid="dept-branch-locked">
            {t("departments.form.branchLocked")}
          </p>
        ) : null}
      </div>
      <div className="sm:col-span-2">
        <span className={LB}>{t("departments.form.manager")}</span>
        <select className={`${IN} mt-1.5`} value={form.manager_id || ""} onChange={set("manager_id")} data-testid="dept-manager">
          <option value="">{t("departments.notAssigned")}</option>
          {managers.map((m) => (
            <option key={m.id} value={m.id}>
              {localName(m)} · {m.email}
              {mgrMap[m.id] ? ` — ${t("departments.form.currentlyManaging", { name: mgrMap[m.id] })}` : ""}
            </option>
          ))}
        </select>
        {manager ? (
          <div className="mt-2">
            <DepartmentManagerRow manager={manager} onRemove={() => onChange({ ...form, manager_id: "" })} />
          </div>
        ) : null}
      </div>
    </>
  );
};
